import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/scroll-top'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import { ToolbarWrapper } from './components/toolbar'
import { ToolbarProvider } from './components/toolbar/Toolbar'
import { UpgradeModal } from '../../app/modules/subscription/UpgradeModal'
import { PendingInvitesBanner } from '../../app/modules/auth/PendingInvitesBanner'
import { FeedbackWidget } from '../../app/modules/widgets/components/FeedbackWidget'
import { useKeepWarm } from '../../app/warmup'
import '../../app/routing/routeTransition.css'



const MasterLayout = () => {
  const location = useLocation()
  useKeepWarm()
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
    <PageDataProvider>
      <ToolbarProvider>
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />

          {/* <ToolbarWrapper /> */}
          <div className='app-wrapper flex-column flex-row-fluid mt-20' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main  flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid mt-5 flex-grow-1'>
                {/* MBAI-176: keyed on pathname (not location.key) so this only replays on an
                    actual screen change, not on query-string-only updates like report filters */}
                <div key={location.pathname} className='myb-route-transition'>
                  <Outlet />
                </div>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}
      
      <ActivityDrawer />
      <RightToolbar />
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      <UpgradeModal />
      <PendingInvitesBanner />
      <FeedbackWidget />
      {/* end:: Modals */}
      <ScrollTop />
      </ToolbarProvider>
      
        {/* Same as */}
       
    </PageDataProvider>
  )
}

export {MasterLayout}
